{
  "projectId": "gen-lang-client-0591064673",
  "appId": "1:428883948965:web:8951d266e34b818444244c",
  "apiKey": "AIzaSyCj4TQTQCMAQ0xeTmW0H8MWIqZtjE3R5G0",
  "authDomain": "gen-lang-client-0591064673.firebaseapp.com",
  "storageBucket": "gen-lang-client-0591064673.firebasestorage.app",
  "messagingSenderId": "428883948965",
  "measurementId": "",
  "oAuthClientId": "428883948965-ddoqv8ltcqiga8aksoq7jegtmvrf6qhi.apps.googleusercontent.com",
  "recaptchaSiteKey": ""
}